(() => {
  const mainImage = document.getElementById('v5-main-image');
  const mainMedia = document.getElementById('v5-mainmedia');
  const lightbox = document.getElementById('v5-lightbox');
  const lightboxImage = document.getElementById('v5-lightbox-image');
  const thumbnails = document.querySelectorAll('.v5-product__thumb');
  const previousButton = lightbox?.querySelector('.v5-lightbox__prev');
  const nextButton = lightbox?.querySelector('.v5-lightbox__next');
  const currentCounter = document.getElementById('v5-lightbox-current');
  const supportTrigger = document.getElementById('v5-support-trigger');
  const supportDialog = document.getElementById('v5-support-dialog');
  const supportMessage = document.getElementById('v5-support-message');
  const supportSend = document.getElementById('v5-support-send');
  const gallerySources = Array.from(thumbnails, (thumbnail) => thumbnail.dataset.v5Src).filter(Boolean);
  let currentIndex = Math.max(0, Array.from(thumbnails).findIndex((thumbnail) => thumbnail.classList.contains('is-active')));

  const showImage = (index) => {
    if (!gallerySources.length) return;
    currentIndex = (index + gallerySources.length) % gallerySources.length;
    const source = gallerySources[currentIndex];

    if (mainImage) {
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = source;
    }

    if (lightboxImage) lightboxImage.src = source;
    thumbnails.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === currentIndex));
    if (currentCounter) currentCounter.textContent = String(currentIndex + 1);
  };

  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      showImage(index);
    });
  });

  const openLightbox = () => {
    if (!lightbox || !mainImage || !lightboxImage) return;
    lightboxImage.src = mainImage.currentSrc || mainImage.src;
    if (currentCounter) currentCounter.textContent = String(currentIndex + 1);
    lightbox.showModal();
  };

  if (mainMedia) {
    mainMedia.addEventListener('click', openLightbox);
    mainMedia.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') openLightbox();
    });
  }

  if (lightbox) {
    lightbox.querySelector('.v5-lightbox__close')?.addEventListener('click', () => lightbox.close());
    previousButton?.addEventListener('click', () => showImage(currentIndex - 1));
    nextButton?.addEventListener('click', () => showImage(currentIndex + 1));
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (event.key === 'ArrowRight') showImage(currentIndex + 1);
    });
  }

  const variantSelect = document.getElementById('v5-variant');
  const price = document.getElementById('v5-price');

  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.options[variantSelect.selectedIndex];
    if (option && price) price.textContent = option.dataset.price;
  });

  supportTrigger?.addEventListener('click', () => supportDialog?.showModal());
  supportDialog?.querySelector('.v5-support-dialog__close')?.addEventListener('click', () => supportDialog.close());
  supportDialog?.addEventListener('click', (event) => {
    if (event.target === supportDialog) supportDialog.close();
  });
  supportSend?.addEventListener('click', () => {
    const message = supportMessage?.value.trim() || 'Merhaba, ürün hakkında destek almak istiyorum.';
    window.open(`https://wa.me/905468763783?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
  });
})();
